import { Backdrop } from "@mui/material";
import FullSizeLoading from "@/components/ui/FullSizeLoading";

type FullScreenLoadingProps = { title?: string };

const FullScreenLoading = (props: FullScreenLoadingProps) => {
  const { title } = props;
  return (
    // exit: 1 stops flicker between two different loading screens
    <Backdrop
      open
      transitionDuration={{ exit: 1 }}
      sx={{
        // oxlint-disable-next-line eslint-js/no-restricted-syntax
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        zIndex: 999,
      }}
    >
      <FullSizeLoading title={title} />
    </Backdrop>
  );
};

export default FullScreenLoading;
